import React from 'react'
import { StyledContainer } from './Container.styled'

export const Container = ({ children }) => {
  return <StyledContainer>{children}</StyledContainer>
}
